module.exports = __webpack_public_path__ + "img/b485795.png";